import { useQuery } from "@tanstack/react-query";
import branchesService from "services/admin/branchesService";

export const useGetBranches = (queryParams = {}) => {
  return useQuery({
    queryKey: ["branches", queryParams],
    queryFn: async () => {
      const response = await branchesService.getAll(queryParams);
      return response.data;
    },
  });
};
